import Types from './Types'

export default Types



// WEBPACK FOOTER //
// ./src/components/Types/index.js